import { Notyf }            from    'notyf';
import 'notyf/notyf.min.css'; // for React and Vue
const notyf = new Notyf({
    duration: 8000,
});

const Methods = {

    data(){
        return{
            notyf,
        }
    },

    watch: {

        "form_data.room_type_id"(val)
        {
            if(val)
            {
                let floor_name = this.array_options['room_type_id'].find((data) => data.id === val)
                const patient = floor_name.patient;
                const name = floor_name.name;
                this.form_data.floor_id = floor_name.floor_id
                
                if(patient || name === "Patient Room")
                {
                    this.form_data.patient = true
                } 
                else
                {
                    this.form_data.patient = false
                }
            }
        },
        
        async 'form_data.building_id'(val)
        {
            if(val)
            {
                let http_request = {
                    request_id:     val,
                    levels_request: true,
                    areas_request:  false,
                }
                const response = await this.get(`${this.rest_api}/${JSON.stringify(http_request)}`);
                if(response.status)
                {
                    if(response.data.levels.length)
                    {
                        this.array_options['level_id'] = response.data.levels
                        this.form_data.level_id = this.array_options.level_id[0].id
                        notyf.success('Levels available for the selected building')
                    }
                    else
                    {
                        this.array_options['level_id'] = []
                        this.form_data.level_id = ''
                        this.array_options['area_id'] = []
                        this.form_data.area_id = ''
                        notyf.error('No levels available for the selected building')
                    }
                }
                else
                {
                    this.error_handling(response)
                }
            }
        },
  
        async 'form_data.level_id'(val)
        {
            if(val)
            {
                let http_request = {
                  request_id:     val,
                  levels_request: false,
                  areas_request:  true,
                }
              
                const response = await this.get(`${this.rest_api}/${JSON.stringify(http_request)}`)
              
                if(response.status)
                {
                    if(response.data.areas.length)
                    {
                        this.array_options['area_id'] = response.data.areas
                        this.form_data.area_id = this.array_options.area_id[0].id
                        notyf.success('Areas available for the selected level')
                    }
                    else
                    {
                        this.array_options['area_id'] = []
                        this.form_data.area_id = ''
                        notyf.error('No areas available for the selected level')
                    }
                }
                else
                {
                    this.error_handling(response)
                } 
            }
        },
        
        'form_data.frequency'(val)
        {
            if(val < 0)
            {
                this.form_data.frequency = 1
            }
        },

    },

    methods: {

        updateDailyFrequencyValue()
        {
            this.calculating_daily_frequency_value = true


            if (this.form_data.frequency) 
            {
                const activeShifts = [this.form_data.daily_shift_1, this.form_data.daily_shift_2, this.form_data.daily_shift_3].filter(Boolean).length;

                if (activeShifts > 1) 
                {
                    this.form_data.frequency = this.form_data.previous_frequency * activeShifts;
                } 
                else
                {
                    this.form_data.frequency = this.form_data.previous_frequency;
                }
            }
            setTimeout(() => {
                this.calculating_daily_frequency_value = false
            }, 200)
        },

        changingDailyTaskFrequency()
        {
            this.calculating_daily_frequency_value = true
            this.form_data.previous_frequency = Number(this.form_data.frequency)

            setTimeout(() => {
                this.updateDailyFrequencyValue()
            }, 400);
        },

        updatePolicingFrequencyValue()
        {
            this.calculating_policing_frequency_value = true


            if (this.form_data.policing_frequency) 
            {
                const activeShifts = [this.form_data.policing_shift_1, this.form_data.policing_shift_2, this.form_data.policing_shift_3].filter(Boolean).length;

                if (activeShifts > 1) 
                {
                    this.form_data.policing_frequency = this.form_data.previous_policing_frequency * activeShifts;
                } 
                else
                {
                    this.form_data.policing_frequency = this.form_data.previous_policing_frequency;
                }
            }
            setTimeout(() => {
                this.calculating_policing_frequency_value = false
            }, 200)
        },

        changingPolicingTaskFrequency()
        {
            this.calculating_policing_frequency_value = true
            this.form_data.previous_policing_frequency = Number(this.form_data.policing_frequency)

            setTimeout(() => {
                this.updatePolicingFrequencyValue()
            }, 400);
        },

        customReportsView()
        {
            this.loader(true)
            window.location.href = '/custom-room-descriptions'
        },

        selectAllBoxes()
        {
            if(this.rooms.length)
            {
                this.rooms.map((item) => {
                    item.checked = this.select_all
                })
            }
        },

        async form_submit(flag = false)
        {
            let rooms_selected = this.$refs.advanced_search.returnedRoomsToParent()

            if(!rooms_selected.checked_items.length)
            {
                notyf.error('No rooms selected')
                return false
            }

            if(!flag)
            {
                window.$('#confirmation-fields-modal').modal('show')
                return false
            }
            else if(flag)
            {
                window.$('#confirmation-fields-modal').modal('hide')
            }

            this.loader(true)

            rooms_selected.checked_items = rooms_selected.checked_items.map(item => item.id)
            rooms_selected.unchecked_items = rooms_selected.unchecked_items.map(item => item.origin_id)

            let json_request = {
                mass_update: true,
            }

            const response = await this.patch(`${this.rest_api}/${JSON.stringify(json_request)}`, {...this.form_data, ...rooms_selected})

            if(response.status)
            {
                notyf.success('Success')
                this.loader()
                this.form_data = {...this.form_backup}

                this.$refs.advanced_search.replacingRooms(response.data.updated_rooms)

            }
            else
            {
                this.loader()
                notyf.error('Error')
                this.error_handling(response)
            }
        },

        getInitialData(data)
        {
            this.array_options = {
                building_id:    data.buildings,
                level_id:       '',
                area_id:        '',
                task_id:        data.tasks,
                room_type_id:   data.room_types,
                floor_id:       data.floors,
                cost_center_id: data.cost_centers,
            }
        },

    },

}

export default Methods